import { type FC, type ReactNode, type PropsWithChildren } from 'react';
import { AppBar, Toolbar, Typography } from '@mui/material';

export type PageHeaderProps = PropsWithChildren<{
  /**
   * Page title
   */
  title: string;

  /**
   * Element to render before the title (e.g., navigation icon)
   * @see https://m2.material.io/components/app-bars-top#anatomy
   */
  navigationIcon?: ReactNode;
}>;

/**
 * Page header component
 * @see https://m2.material.io/components/app-bars-top#anatomy
 */
export const PageHeader: FC<PageHeaderProps> = ({
  title,
  navigationIcon,

  children,
}) => (
  <AppBar position="sticky">
    <Toolbar>
      {navigationIcon}
      <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
        {title}
      </Typography>
      {children}
    </Toolbar>
  </AppBar>
);
